import { ProfilePictureLoader } from "../profilePictures/profilePictureLoader";
import { Image } from "semantic-ui-react";

type Props = {
    playerName: string;
}

const ProfilePicture = ({ playerName }: Props) => {
    const picture = ProfilePictureLoader(playerName);

    return (
        <div style={{ display: "flex", alignItems: "center", gap: "1em" }}>
            <div style={{ width: 35, height: 35 }}>
                {picture &&
                    <Image
                        src={picture}
                        alt={playerName}
                        size="mini"
                        style={{ width: '100%', height: '100%' }}
                    />
                }
            </div>
            <p>
                {playerName}
            </p>
        </div>
    )
}

export default ProfilePicture;